<template>
  <div>
    <div class="clear"></div>
    <!-- Content
    =============================================-->
    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
          <!-- Page Title
          =============================================-->
          <!-- <section id="page-title">
            <div class="container clearfix">
              <h1>วิธีเช่าชุด</h1>
            </div>
          </section>-->
          <div class="faq_title">
            คำถามที่พบบ่อย
          </div>
          <!-- #page-title end -->

          <!-- Post Content
          =============================================-->
          <div class="row">
            <div
              class="postcontent nobottommargin clearfix"
              style="max-width:1150px; !important; margin-left: auto; margin-right: auto;"
            >
              <div id="faqs" class="faqs">
                <div class="toggle faq faq-marketplace faq-authors">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-question-alt"></i>1.
                    ร้านเช่าชุดอยู่ที่ไหน ?
                  </div>
                  <div class="togglec">
                    ร้านตั้งอยู่ในซอยวัดส้มเกลี้ยง  ปลายบาง  จังหวัดนนทบุรี  <br />
                    อยู่ตึกแถวเดียวกับร้านใส่นม  ขึ้นได้ทางร้านใส่นม <br />
                    ร้านเสื้อจะตั้งอยู่บนชั้น 3,4 ของร้านใส่นม <br />
                    ทางร้านมีพื้นที่ให้เลือกชมประมาณ 180 ตร.ม.
                   
                  </div>
                </div>

                <div class="toggle faq faq-authors faq-miscellaneous">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>2.
                    ขั้นตอนในการจองผ่านเว็บไซด์ วางแผนการรับชุดอย่างไร?
                  </div>
                  <div class="togglec">
                    ลูกค้าเช็คคิววันว่างของชุดที่ลูกค้าต้องการผ่านเว็บไซต์  <br />
                    ถ้าชุดที่ลูกค้าต้องการมีคิวว่างลูกค้าสามารถแคปหน้าจอหรือชื่อรหัสสินค้า <br />
                    แจ้งแอดมินทางไลน์@ แอดมินจะทำการออกใบจองชุดให้ลูกค้า <br />
                    ใบจองจะสำเร็จก็ต่อเมื่อลูกค้าได้ชำระเงิน  <br />
                    ค่าเช่าชุด + ค่ามัดจำ ครบเรียบร้อยแล้ว  <br />
                    ในกรณีที่ลูกค้าไม่สะดวกเข้ามารับชุดที่หน้าร้าน <br />
                    ทางร้านมีบริการจัดส่งให้ ส่งEMS <br />
                    โดยมีค่าใช้จ่าย 100 บาท/บิล  <br />
                    ถ้าลูกค้าต้องการชุดแบบเร่งด่วนลูกค้าสามารถเรียกแมสเซนเจอร์เข้ามารับที่หน้าร้านได้<br />


                  </div>
                </div>

                <div class="toggle faq faq-miscellaneous">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>3. 
                    หากส่งคืนล่าช้ากว่ากำหนด ทางร้านมีค่าใช้จ่ายเพิ่มไหม ?
                  </div>
                  <div class="togglec">
                    ชุดของทางร้านมีระยะเวลาการเช่า  7  วัน <br />
                    (ถ้าลูกค้าส่งรีวิวให้ทางร้าน ทางร้านเพิ่มระยะเวลาการเช่าให้ 3 วัน)  <br />
                    ในกรณีที่ลูกค้าคืนชุดเกินกว่ากำหนดจะมีค่าบริการเพิ่มวันละ 50 บาท/ชุด
                    <br />
                    
                  </div>
                </div>

                <div
                  class="toggle faq faq-authors faq-legal faq-itemdiscussion"
                >
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>4.
                    ค่ามัดจำชุดคิดอย่างไร ?
                  </div>
                  <div class="togglec">
                    ค่ามัดจำชุด จะชำระเท่ากับค่าเช่าชุด เช่น ค่าเช่าชุดราคา 500 บาท <br />
                    ค่ามัดจำที่ลูกค่าต้องจ่าย =500 บาท <br />
                    (เงินมัดจำลูกค้าจะได้คืนเต็มจำนวนในกรณีที่ทางร้านได้รับชุดและตรวจสอบชุดเรียบร้อย  <br />
                    ทางร้านจะโอนเงินค่ามัดจำชุดคืนลูกค้าภายใน 48 ชั่วโมง)<br />
                    <br />
                    
                  </div>
                </div>

                <div class="toggle faq faq-marketplace faq-authors">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i
                    >5.	Accessories มีค่าใช้เพิ่มไหม ?
                  </div>
                  <div class="togglec">
                    ถ้าลูกค้าเช่าชุดครบ 1,000 บาทจะได้รับของเช่า แถมฟรี 5 รายการ<br />
                    ถ้าลูกค้าเช่าชุดครบ 2,000 บาทจะได้รับของเช่า แถมฟรี 10 รายการ<br />
                    เช่น หมวก,ถุงมือ,ผ้าพันคอ,ถุงเท้า,แผ่นแปะร้อน,เครื่องชั่งน้ำหนักกระเป๋า,หมอนรองคอ และอื่นๆ<br />
                    ถ้าลูกค้าเช่าไม่ถึงถึงราคาที่ทางร้านกำหนด ลูกค้าสามารถเช่าเพิ่มได้ในราคาชิ้นละ 50 บาท<br />

                  </div>
                </div>

                <div class="toggle faq faq-affiliates faq-miscellaneous">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i
                    >6. ลูกค้าต้องทำความสะอาดชุดก่อนส่งคืนไหม ?
                  </div>
                  <div class="togglec">
                    ลูกค้าใช้ชุดเสร็จสามารถนำส่งคืนทางร้านได้โดยไม่ต้องทำความสะอาด <br />
                    ทางร้านมีบริการทำความสะอาดชุดทั้งก่อนและหลังการเช่า<br />
                  </div>
                </div>

                <div class="toggle faq faq-legal faq-itemdiscussion">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>7.
                    หากชุดเสียหาย ปรับอย่างไรคะ?
                  </div>
                  <div class="togglec">
                    หากชุดมีรอยเลอะที่สามารถซักออกได้หรือชำรุดเพียงเล็กน้อยเช่น กระดุมหลุด ทางร้านไม่หักค่าปรับ<br />
                    หากชุดเกิดความเสียหายหนักที่ไม่สามารถแก้ไขได้เช่น เลอะหมึกขนาดใหญ่  ชุดฉีกขาดเป็นจำนวนมาก  <br />
                    ทางร้านจะหักค่าประกันชุดตามความเหมาะสม<br />

                  </div>
                </div>

                <div class="toggle faq faq-legal faq-itemdiscussion">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>8.
                    สามารถยกเลิกรายการเช่าชุดหรือเปลี่ยนแบบได้หรือไม่?
                  </div>
                  <div class="togglec">
                    ลูกค้าเช่าชุดแล้วต้องการยกเลิก ทางร้านไม่คืนเงินในทุกกรณี แต่ลูกค้าสามารถเก็บสิทธิ์ไว้เช่าครั้งถัดไปได้ค่ะ<br />
                     โดยต้องแจ้งก่อน 14 วันก่อนการเดินทาง<br /><br />

                    หากลูกค้าต้องการเปลี่ยนแบบชุดแจ้งก่อนวันเดินทาง 14 วัน โดยไม่มีค่าใช้จ่าย
                    หากลูกค้าแจ้งในระยะเวลา 5-14 วันก่อนเดินทาง ทางร้านขออนุญาตหักเงินมัดจำ 50%
                    หากลูกค้าภายใน 5 วันก่อนเดินทาง ทางร้านขออนุญาตหักเงินมัดจำเต็มจำนวน 100%

                  </div>
                </div>

                <div class="toggle faq faq-legal faq-itemdiscussion">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>9.
                    วิธีเลือกไซส์
                  </div>
                  <div class="togglec">
                   

                ลูกค้าดูขนาดจากรูปในเวป และวัดไซส์ของตัวเอง ควรเผื่อไซส์จากสัดส่วนรอบอกจริงของตัวเอง<br>

                - เสื้อขนเป็ด(เสื้อพองๆผ้าร่ม) 4 นิ้ว<br>
                - โค้ทวูล (ชุดยาวทรงตรง) 4 นิ้ว<br>
                - โค้ทเฟอร์ (เสื้อขนเฟอร์) 4นิ้ว<br>
                - เสื้อแจ็คเก็ต (เสื้อหนังหรือเสื้อคลุมทั่วไป)  2 นิ้ว<br>
                - เทรนซ์โค้ท (เสื้อทรงยาวเรียวผ้าไม่หนามาก) 2 นิ้ว<br>

                  </div>
                </div>


              </div>
            </div>
          </div>
          <!-- ROW -->
          <!-- .postcontent end -->
        </div>
      </div>
    </section>
    <!-- #content end -->
  </div>
</template>
<script>
import myMixins from "@/mixins/myMixins.js";
export default {
  mixins: [myMixins],
  data() {
    return {
      welcome: "This is your profile",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    welcomeMessage() {},
  },
  components: {},
};
</script>

<style>
.toggle {
  text-align: left;
}
.togglec {
  text-align: left;
}

.faq_title {
  font-size: 48px;
  font-weight: 500;
  padding-left: 120px;
  text-align: left;
  padding-bottom: 60px;
  padding-top: 50px;
}

@media only screen and (max-width: 578px) {
  .faq_title {
    font-size: 36px !important;
    font-weight: 500;
    padding-left: 10px !important;
    text-align: left;
    padding-bottom: 60px;
    padding-top: 50px;
  }
}
</style>